import apiClient from '@/api/client';
import { getActiveHospitalId, getActiveClinicId } from '@/constants';

const getTodayStr = () => new Date().toISOString().split('T')[0];

export const reportService = {
  /**
   * GET /pms/hospital/{hospitalId}/reports/analytics
   */
  getAnalytics: async (filters = {}, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = filters.clinicId && filters.clinicId !== 'all' ? getActiveClinicId(filters.clinicId) : undefined;
    const res = await apiClient.get(`/hospital/${activeHospId}/reports/analytics`, {
      params: {
        clinicId: activeClinicId,
        doctorId: filters.doctorId !== 'all' ? filters.doctorId : undefined,
        startDate: filters.startDate,
        endDate: filters.endDate,
      },
    });
    return res.data || res;
  },

  /**
   * GET /pms/hospital/{hospitalId}/reports/export
   */
  exportReport: async (format = 'csv', hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const response = await apiClient.get(`/hospital/${activeHospId}/reports/export`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `pulseflow-pms-report-${getTodayStr()}.${format}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return { success: true };
  },
};

export default reportService;
